import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import i18n from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import Et3ATag from "../../../../../core/et3-a-tag";
import getKhattabatSharedMessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import getKhattabat102MessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/102-messaging-store";

const ConversationType = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { theme, conversationID } = props;
  const { colors, unitX } = theme;

  const { conversationType } = getKhattabatSharedMessagingStore(conversationID);
  const { matchReceiverID, matchReceiverName, isSilentBanned } =
    getKhattabat102MessagingStore(conversationID);
  const headerText =
    conversationType.get() === "101C"
      ? "ONE_O_ONE_C"
      : conversationType.get() === "101C_COMMENTS"
        ? "COMMENTS"
        : "ONE_O_TWO_WITH";

  return (
    <ET3Div
      width={0}
      height={45}
      alignItems={"center"}
      fDirection={"row"}
      style={{ width: "auto" }}
      color={""}
      justifyContent={"flex-end"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3Margin top={0} bottom={0} left={10} right={10} />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get(headerText)}
        style={{}}
        color={
          conversationType.get() === "101C_COMMENTS"
            ? colors.all.red
            : colors.all.black
        }
      />
      <Et3Margin top={0} bottom={0} left={5} right={5} />
      {conversationType.get() === "102" ? (
        <>
          <Et3ATag
            href={`/users/advanced?id=${matchReceiverID.get()}`}
            target="_blank"
            style={{}}
          >
            <Et3Text
              fontFamily={"MEDIUM"}
              fontSize={24}
              isSpan={false}
              text={matchReceiverName.get()}
              style={{}}
              color={colors.all.black}
            />
          </Et3ATag>
          {isSilentBanned.get() === 1 ? (
            <ET3Div
              isScrollable={false}
              isExtendable={false}
              fDirection="row"
              justifyContent="center"
              alignItems="center"
              withShadow={false}
              width={28}
              height={24}
              color={colors.all.red}
              style={{
                marginLeft: 6 * unitX,
                borderRadius: 4
              }}
              onClick={() => {}}
            >
              <Et3Text
                fontFamily="BOLD"
                fontSize={12}
                text={i18n.get("SILENT_BAN_ABBREVIATION")}
                isSpan={false}
                color={colors.all.white}
                style={{}}
              />
            </ET3Div>
          ) : null}
        </>
      ) : null}
    </ET3Div>
  );
});

export default ConversationType;
